import React, {Component} from 'react';
import {connect} from 'react-redux';
import NotificationAlert from "react-notification-alert";
import {hideGlobalNotification} from '../../../store/actions/globalNotification';
import {NOTIFICATION_SUCCESS} from "../../../store/actions/types";

class GlobalNotificationComponent extends Component {
  notify = () => {
    let options = {
      place: "tc",
      message: (
        <div>
          <span>
            {this.props.message}
          </span>
        </div>
      ),
      type: this.props.type === NOTIFICATION_SUCCESS ? 'success' : 'error',
      icon: "ni ni-bell-55",
      autoDismiss: 10,
    };

    this.props.hideGlobalNotification();

    this.refs.notificationAlert.notificationAlert(options);
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.showGlobalNotification) {
      this.notify();
    }
  }

  render() {
    return (<div className="rna-wrapper global-notification-container">
        <NotificationAlert ref="notificationAlert"/>
      </div>

    );
  }
}

const mapStateToProps = (state) => ({
  message: state.globalNotification.message,
  type: state.globalNotification.type,
  showGlobalNotification: state.globalNotification.showGlobalNotification
});

const mapActionsToProps = {
  hideGlobalNotification,
};

const GlobalNotification = connect(mapStateToProps, mapActionsToProps)(GlobalNotificationComponent);

export {GlobalNotification};
